import { nav } from "../../../common/helpers/nav";
function dcAdminNavController(
  UserService,
  FlashService,
  UsersModel,
  $state,
  $rootScope,
  DrivesFilterService,
) {
  const vm = this;
  vm.currentUser = UserService.getCurrentUser();
  // Organisations with many schools would push the rest of the nav down, so
  // the school switcher starts collapsed under "Franchises".
  vm.franchisesOpen = false;
  vm.switchToSchool = switchToSchool;
  vm.showFranchiseLinks = () =>
    vm.currentUser.franchise_owner === true &&
    vm.currentUser.role.type === "owner" &&
    !!vm.currentUser.organisation &&
    vm.currentUser.organisation.schools.length > 1;

  function reloadCurrentState() {
    // if( $rootScope.currentState ){
    //     $state.go($rootScope.currentState.name, $rootScope.currentState.params, {'reload' : true});
    // }else{
    $state.go("drivecoach.admin.dashboard", {}, { reload: true });
    // }
  }

  function switchToSchool(schoolID) {
    UsersModel.switchToSchool(schoolID).then(function (response) {
      response.user.access_token = UserService.getCurrentUser().access_token;
      UserService.setCurrentUser(response.user);
      DrivesFilterService.clearFilterOptions();
      DrivesFilterService.clearFilterOptions();
      FlashService.setMessage({
        type: "success",
        message: response.message,
      });
      reloadCurrentState();
    });
  }

  nav();
}
dcAdminNavController.$inject = [
  "UserService",
  "FlashService",
  "UsersModel",
  "$state",
  "$rootScope",
  "DrivesFilterService",
];

export default dcAdminNavController;
